import _ from 'helpers/no_conflict_lodash';

export default class RansackQuery {

  constructor(queryValues, keys) {
    this.queryValues = queryValues;
    this.keys = keys;
  }

  toRansack() {
    return _.mapKeys(this.queryValues, (_value, key) => this.keys[key] || key);
  }
}
